// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ff50fc9a","769":"837a6a25"}[chunkId] + ".chunk.js";
};